import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Icon,
  ListItem,
  Tooltip,
  Typography,
} from "@mui/material";

import { IconCloudDownload, IconLoader, IconTrashX } from "@tabler/icons-react";
import { useUsuario } from "../../../../providers/usuarioProvider";
import Upload from "../../../../models/upload";
import { deleteDoc } from "firebase/firestore";
import UploadDb from "../../../../db/uploadDb";
import ChipTipoUpload from "../../../util/ui/chipTipoUpload";
import ChipExtensao from "../../../util/ui/chipExtensao";
import { getDownloadURL, getStorage, ref } from "firebase/storage";

type Props = {
  upload: Upload;
};
export default function UploadImportando({ upload }: Props) {
  const { visualizado } = useUsuario();

  return (
    <ListItem disableGutters sx={{ px: 2, py: 1 }}>
      <Box display="flex" flexDirection="column" width="100%" gap={0.75}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          width="100%"
        >
          <Icon
            fontSize="inherit"
            sx={(theme) => ({
              width: 16,
              color: theme.palette.accentInk,
              display: "inline-flex",
              animation: "felixSpin 1.2s linear infinite",
              "@keyframes felixSpin": {
                from: { transform: "rotate(0deg)" },
                to: { transform: "rotate(360deg)" },
              },
            })}
          >
            <IconLoader size={16} strokeWidth={3} />
          </Icon>
          <Tooltip title={upload.nomeArquivoOriginal || ""} placement="top">
            <Box
              display="flex"
              flexGrow={1}
              minWidth={0}
              px={1}
              alignItems="center"
              gap={1}
            >
              <Typography
                variant="body1"
                component="div"
                color="text.secondary"
                noWrap
                sx={{ minWidth: 0 }}
              >
                Importando{" "}
                <Typography
                  variant="dataMono"
                  component="span"
                  color="text.primary"
                >
                  {upload.nomeArquivoOriginal}
                </Typography>
                ...
              </Typography>
            </Box>
          </Tooltip>
          <Box display="flex" gap={0.5} alignItems="center" mr={1}>
            <Chip
              label="Processando"
              size="small"
              sx={(theme) => ({
                backgroundColor: theme.palette.statusChip.accent.bg,
                color: theme.palette.statusChip.accent.fg,
              })}
            />
            <ChipTipoUpload tipo={upload.tipo} />
            <ChipExtensao nomeArquivo={upload.nomeArquivoOriginal} />
          </Box>
          <ButtonGroup size="small" variant="outlined">
            <Button
              color="info"
              size="small"
              onClick={async () => {
                if (upload.arquivo) {
                  const url = await getDownloadURL(
                    ref(getStorage(), upload.arquivo),
                  );
                  window.open(url, "_blank");
                }
              }}
            >
              <IconCloudDownload size={16} />
            </Button>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                if (!!visualizado)
                  await deleteDoc(
                    new UploadDb().doc({
                      usuarioId: visualizado,
                      uploadId: upload.id,
                    }),
                  );
              }}
            >
              <IconTrashX size={16} />
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
    </ListItem>
  );
}
